module.exports = __webpack_public_path__ + "media/images/undraw_cooking_re_g99p-91e204af9d3e4d6a6bcee8b29dc12a4e.svg";